import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdatePositionParam {
  classId: string;
  waitlistId: string;
  newPosition: number;
}

export const updatePositionAPI = async ({
  waitlistId,
  newPosition,
}: UpdatePositionParam) => {
  const resp = await baseAPI.put<unknown>('/waitlist/position', {
    waitlistId,
    newPosition,
  });
  return resp.data;
};

export const useUpdatePositionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: UpdatePositionParam) => {
      const response = await updatePositionAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WAIT_LIST_SUMMARY, params.classId],
      });
    },
  });
};
